import { useTranslation } from "react-i18next"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Button,
} from "@f2e/ui/components/base"

export interface UnsavedChangesWarningProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  onCancel: () => void
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
  translationKeys?: {
    title?: string
    description?: string
    confirm?: string
    cancel?: string
  }
}

export const UnsavedChangesWarning = ({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  title,
  description,
  confirmText,
  cancelText,
  translationKeys,
}: UnsavedChangesWarningProps) => {
  const { t } = useTranslation()

  // Use custom translation keys if provided, otherwise use defaults
  const defaultKeys = {
    title: "workspace.agent.historyChangeWarning.title",
    description: "workspace.agent.historyChangeWarning.description",
    confirm: "workspace.agent.historyChangeWarning.confirm",
    cancel: "workspace.agent.historyChangeWarning.cancel",
  }

  const keys = translationKeys || defaultKeys

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {title || t(keys.title!, "Unsaved Changes")}
          </DialogTitle>
          <DialogDescription>
            {description ||
              t(
                keys.description!,
                "You have unsaved changes that will be lost. Do you want to continue?"
              )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            {cancelText || t(keys.cancel!, "Cancel")}
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            {confirmText || t(keys.confirm!, "Continue")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
